import type {
    Pagination,
    StandardDrinkSubstitution,
} from '@barboxx/models/types';

import { api } from '../../api';

const rootPath = 'standard-drinks/substitutions';

export function getStandardDrinkSubstitutions(
    query: StandardDrinkSubstitution.SearchQuery
) {
    return api.get<Pagination<StandardDrinkSubstitution>>(rootPath, query);
}

export function getStandardDrinkSubstitution(id: number) {
    return api.get<StandardDrinkSubstitution.DetailsResponse>(
        `${rootPath}/${id}`,
        undefined
    );
}

export function postStandardDrinkSubstitution(
    data: StandardDrinkSubstitution.CreateRequest
) {
    return api.post<StandardDrinkSubstitution>(rootPath, data);
}

export function putStandardDrinkSubstitution(
    id: number,
    data: StandardDrinkSubstitution.UpdateRequest
) {
    return api.put<StandardDrinkSubstitution>(`${rootPath}/${id}`, data);
}

export function deleteStandardDrinkSubstitution({
    id,
}: StandardDrinkSubstitution.DeleteRequest) {
    return api.delete(`${rootPath}/${id}`, undefined);
}
